import * as React from 'react';
import {Modal, Button} from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import {ProductsListState} from 'app/pages/DiscountEditor/modules/ProductSelection';
import {ProductType, getProductTypeDisplayName} from 'app/shared/model';
import {ProductFilterType, ProductFilter, setProductType, setProductFilterType} from 'app/shared/model/ProductFilter';
import ConnectedProductSelectionEditor from 'app/pages/DiscountEditor/components/ConnectedProductSelectionEditor';
import { Dispatch } from 'redux';
import { Action, AdditionalCriteriaType } from 'app/pages/DiscountEditor/actionTypes';
import { getAddOrEditModal, getAdditionalProductFilterType, getAdditionalProductFilter } from 'app/pages/DiscountEditor/modules/AdditionalCriteria';
import { connect } from 'react-redux';
import { setAdditionalCriteraProductFilter, setAddOrEditCriteriaModal } from 'app/pages/DiscountEditor/actions';
import { ProductFilterAllowedOptions } from 'app/pages/DiscountEditor/components/ProductSelection';
import { UnitsFilter, UnitsFilterType } from 'app/shared/model/ProductUnitFilter';
import { canEditApplicableProducts } from 'app/pages/DiscountEditor/modules/ProductSelection';

interface OpenStateProps {
    isOpen: true,
    productType?: ProductType,
    initialUnitsFilter?: UnitsFilter,
    initialProductFilter?: ProductFilter
}

interface ClosedStateProps {
    isOpen: false,
    productType?: ProductType,
    initialUnitsFilter?: UnitsFilter,
    initialProductFilter?: ProductFilter
}

type StateProps = OpenStateProps|ClosedStateProps;

interface DispatchProps {
    save: (productsFilter: ProductFilter, unitsFilter: UnitsFilter) => void
    cancel: () => void
}

type InternalProps = StateProps&DispatchProps;

type InternalState = {
    productFilter?: ProductFilter
    unitsFilter?: UnitsFilter
}

class ExtraCriteriaDialog extends React.Component<InternalProps, InternalState> {
    constructor(props: InternalProps) {
        super(props);
        this.state = {
            productFilter: props.initialProductFilter,
            unitsFilter: props.initialUnitsFilter
        }
    }

    render() {
        const props = this.props;
        if (!props.isOpen)
            return <div></div>;
        return <Modal open onCancel={props.cancel} title={`Additional ${getProductTypeDisplayName(props.productType!).toLocaleLowerCase()} criteria`} 
                footer={[
                    <Button key="cancel" onClick={props.cancel}>Cancel</Button>,
                    <Button key="save" type="primary" icon={<CheckOutlined />} onClick={this.save.bind(this)}>Save</Button>
                ]}>
                {props.isOpen && 
                    <ConnectedProductSelectionEditor 
                        productFilter={this.state.productFilter}
                        changeProductFilter={this.changeProductFilter.bind(this)}
                        unitFilter={this.state.unitsFilter}
                        changeUnitFilter={this.changeUnitsFilter.bind(this)}
                        allowedFilterOption={ProductFilterAllowedOptions.DisallowProductTypeChange}
                        allowUnitFilter
                    />
                }
        </Modal>
    }

    private save() {
        const productFilter = this.state.productFilter;
        const unitsFilter = this.state.unitsFilter;
        if (!productFilter || !unitsFilter)
            return;

        this.props.save(productFilter, unitsFilter);
    }

    private changeProductFilter(filter: ProductFilter) {
        this.setState({
            productFilter: filter
        })
    }

    private changeUnitsFilter(filter: UnitsFilter) {
        this.setState({
            unitsFilter: filter
        })
    }

    componentWillReceiveProps(nextProps: InternalProps) {
        if (nextProps.isOpen && !this.props.isOpen) {
            
            this.setState({
                productFilter: nextProps.initialProductFilter,
                unitsFilter: nextProps.initialUnitsFilter
            });
        }

        if (!nextProps.isOpen && this.props.isOpen) {
            this.setState({
                productFilter: undefined
            });
        }
    }

}

function mapStateToProps(state: any, props: {}) : StateProps {
    if (!canEditApplicableProducts(state))
        return { isOpen: false };

    const currentFilter = getAdditionalProductFilter(state);
    const productType = getAdditionalProductFilterType(state);
    if (currentFilter === undefined || productType === undefined)
        return {isOpen: false};

    const productFilter : ProductFilter = currentFilter.hasCriteria 
        ? currentFilter.productFilter
        : {type: ProductFilterType.IncludeSpecific, productType: productType, productCodes: {}};

    const unitsFilter : UnitsFilter = currentFilter.hasCriteria 
        ? currentFilter.unitsFilter
        : {type: UnitsFilterType.None};

    return {
        isOpen: true,
        initialProductFilter: productFilter,
        productType: productType,
        initialUnitsFilter: unitsFilter
    }
}

function mapDispatchToProps(dispatch: Dispatch<Action>) : DispatchProps {
    return {
        save: (productFilter: ProductFilter, unitsFilter: UnitsFilter) => 
            dispatch(setAdditionalCriteraProductFilter(productFilter, unitsFilter)),
        cancel: () => dispatch(setAddOrEditCriteriaModal(AdditionalCriteriaType.None))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExtraCriteriaDialog as any);